import React from "react"
import styled from "styled-components"
import Link from "../../commons/Link"

const TfsBox = () => {

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "10% 80% 10%",
        margin: "50px 0 100px 0"
      }}
    >
      <div></div>
      <Container>
        <h4
          style={{
            fontSize: "20px",
            color: "#222",
            letterSpacing: "0.3px",
            marginBottom: "20px",
          }}
        >
          Con l'anticipo TFS potrai ricevere subito la tua liquidazione e dare
          vita ai tuoi progetti!
        </h4>
        <Link
          link={"/anticipo-tfs"}
          text={"Scopri il nostro anticipo tfs"}
          textStyle={{ textTransform: "uppercase" }}
        />
      </Container>
      <div></div>
    </div>
  )
}

export default TfsBox

// region Style
const Container = styled.div`
  background: #fff;
  border-left: solid 5px #fcbb00;
  padding: 3rem 1.5rem;
  text-align: center;
`
// endregion

